const SESSION_HINT_KEY = 'appSessionActive';

export function setSessionHintActive() {
  localStorage.setItem(SESSION_HINT_KEY, '1');
}

export function clearSessionHint() {
  localStorage.removeItem(SESSION_HINT_KEY);
}

export function hasSessionHint() {
  return localStorage.getItem(SESSION_HINT_KEY) === '1';
}

/**
 * Exchange a Firebase ID token for the app __session JWT cookie.
 * @returns {Promise<{ ok: boolean, error?: string }>}
 */
export async function verifyFirebaseSession(firebaseUser, apiBaseUrl = '') {
  if (!firebaseUser) return { ok: false, error: 'No Firebase user' };

  try {
    const token = await firebaseUser.getIdToken();
    const base = apiBaseUrl || '';
    const response = await fetch(`${base}/api/auth/verify-token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'include',
    });

    if (response.ok) {
      return { ok: true };
    }

    let error = 'Verification failed';
    try {
      const data = await response.json();
      if (data?.error) error = data.error;
    } catch (_) {
      // ignore parse errors
    }
    return { ok: false, error };
  } catch (err) {
    return { ok: false, error: err.message || 'Connection failed' };
  }
}

export function isTransientAuthCheckError(err) {
  if (!err?.response) return true;
  const status = err.response.status;
  return status >= 500 && status <= 599;
}

export function sleep(ms) {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
}
